<i18n lang="yaml">
zh:
  idcard_front: "头像面"
  idcard_front_tip: "上传您的身份证头像面"
  idcard_back: "国徽面"
  idcard_back_tip: "上传您的身份证国徽面"
  image_add_fail: "图片增加失败"
en:
  idcard_front: "Front Side"
  idcard_front_tip: "Upload the front side of your ID card"
  idcard_back: "Back Side"
  idcard_back_tip: "Upload the back side of your ID card"
  image_add_fail: "Failed to add image"
</i18n>
<template>
<div style="width: 600px;">
  <el-upload
    action="#"
    :on-success="handlePreview"
    :on-remove="handleRemove"
    :file-list="fileList"
    list-type="picture"
    :show-file-list="false"
    :limit="limit"
    :http-request="httpRequest"
    accept="image/jpeg,image/png,image/jpg">
    <el-card slot="trigger" style="background: #EAEBF0;border-radius: 0.38rem 0.38rem 0.38rem 0.38rem;cursor: pointer;">
      <div v-if="direction === 'front'" style="display: flex;gap: 20px;">
        <div style="display: flex;flex-direction: column;text-align: left;">
          <div class="idcard-title" style="font-weight: bold;">{{$t('idcard_front')}}</div>
          <div class="idcard-tip" style="color: rgba(36, 36, 36, 0.30);">{{$t('idcard_front_tip')}}</div>
        </div>
        <div v-if="fileList.length > 0">
          <el-image
            style="width:200px"
            :src="fileList.map(item => item.url)[0]"
            :preview-src-list="fileList.map(item => item.url)"
          />
        </div>
        <img v-else src="@/assets/id-card-front.png" style="width: 200px;">
      </div>
      <div v-else style="display: flex;gap: 20px;">
        <div style="display: flex;flex-direction: column;text-align: left;">
          <div class="idcard-title" style="font-weight: bold;">{{$t('idcard_back')}}</div>
          <div class="idcard-tip" style="color: rgba(36, 36, 36, 0.30);">{{$t('idcard_back_tip')}}</div>
        </div>
        <div v-if="fileList.length > 0">
          <el-image
            style="width:200px"
            :src="fileList.map(item => item.url)[0]"
            :preview-src-list="fileList.map(item => item.url)"
          />
        </div>
        <img v-else src="@/assets/id-card-back.png" style="width: 200px;">
      </div>
    </el-card>
  </el-upload>

</div>
</template>

<script>
import  * as AliossApi from '@/api/alioss'
const OSS = require('ali-oss');
export default {
  name: 'RichEditor',
  props: {
    direction: {
      type: String,
      default: 'front'
    },
    picSize: {
      type: String,
      default: '160x160'
    },
    url: {
      type: String,
      default: ''
    },
    limit: {
      type: Number,
      default: 1
    }
  },
  mounted() {
    if(this.url){
      this.url.split(',').forEach((item,inex)=>{
        this.fileList.push({name: '', url: item})
      })
    }
  },
  computed: {

  },
  data() {
    return {
        fileList: []
    }
  },
  methods: {
    async httpRequest(item) {
      console.log('httpRequest', item);
      var that = this;
      var file = item.file

      let fileType = file.type.toLowerCase()
      let ext
      if(fileType.indexOf('image') >= 0){
        ext = '.jpeg';
      }

      let storeAs = process.env.VUE_APP_CURRENTMODE + '/' + Number(new Date().getTime()/(3600*24*7*1000)).toFixed(0) + '/' + that.guid().replace(/-/g,'') + ext
      console.log(storeAs);

      let res = await AliossApi.ststoken()
      const result = res.data.data
      const client = new OSS({
        accessKeyId: result.accessKeyId,
        accessKeySecret: result.accessKeySecret,
        stsToken: result.stsToken,
        endpoint: result.endpoint,
        bucket: result.bucket
      })
      client.put(storeAs, file).then(result => {
        let picUrl = result.res.requestUrls[0];
        that.fileList.push({name: file.name, url: picUrl})
        console.log('picUrl', picUrl, that.fileList);
        that.$emit('update', that.fileList.map(item => item.url).join(','))

        let url =  picUrl.split("?")[0];
        if (url != null && url.length > 0) {

        } else {
          that.$message.warning(that.$t('image_add_fail'))
        }
      }).catch(function(err) {})
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
      let temp = []
      this.fileList = temp.concat(fileList)
    },
    handlePreview() {
      console.log('handlePreview', 1);
      // picUrl
    },
    guid() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g,
       (c) => {
          var r = (Math.random() * 16) | 0
          var v = c == 'x' ? r : (r & 0x3) | 0x8
          return v.toString(16)
        })
    },
  },
  watch: {
    url(newVal) {
      if(newVal){
        this.fileList = []
        this.url.split(',').forEach((item,inex)=>{
          this.fileList.push({name: '', url: item})
        })
      }
    }
  }
}
</script>

<style scoped lang="scss">

</style>
